<template>
  <div v-if="agentEmail" class="phone-dock">
    <iframe
      v-show="isOpen"
      class="phone-dock-frame"
      :src="frameUrl"
      :allow="framePermissions"
      title="Phone"
    />
    <button
      class="phone-dock-toggle"
      :class="{ 'needs-setup': !isOpen && !isRegistered }"
      :title="toggleTitle"
      @click="isOpen = !isOpen"
    >
      <span v-if="isOpen">&#10005;</span>
      <span v-else>&#128222;</span>
      <span v-if="!isOpen && !isRegistered" class="phone-dock-badge">!</span>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const BRIDGE_BASE = 'https://calls.saevah.site/softphone';
const BRIDGE_SECRET = 'hLt1kjv5glNRJ4lky9eaRFUoz5GjWTD8EJGAypEdUDw';

export default {
  name: 'PhoneDock',
  data() {
    return { isOpen: false, isRegistered: false };
  },
  mounted() {
    // The incoming-call toast asks us to open, because the panel owns
    // the WebRTC leg and is where the call is actually answered.
    this.openDock = () => {
      this.isOpen = true;
    };
    window.addEventListener('phone-dock:open', this.openDock);
    // 2026-10-27: one-click answer from the incoming-call toast.
    this.answerFromToast = event => {
      const ccid = event && event.detail && event.detail.ccid;
      if (!ccid) return;
      this.isOpen = true;
      const frame = this.$el && this.$el.querySelector('iframe');
      if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage({ type: 'phone-panel:answer', ccid }, new URL(BRIDGE_BASE).origin);
      }
    };
    window.addEventListener('phone-dock:answer', this.answerFromToast);

    // The panel posts its registration state so the dock can show whether
    // this agent is actually reachable, not merely logged in.
    this.onPanelState = event => {
      const data = event && event.data;
      if (!data) return;
      // A call ringing inside the collapsed panel cannot be seen, so the
      // panel asks to be opened. Without this a transferred call rings out
      // behind a closed dock.
      if (data.type === 'phone-dock:open') {
        this.isOpen = true;
        return;
      }
      if (data.type !== 'phone-panel:state') return;
      this.isRegistered = Boolean(data.registered);
    };
    window.addEventListener('message', this.onPanelState);
  },
  beforeUnmount() {
    window.removeEventListener('phone-dock:open', this.openDock);
    window.removeEventListener('phone-dock:answer', this.answerFromToast);
    window.removeEventListener('message', this.onPanelState);
  },
  computed: {
    ...mapGetters({ currentUser: 'getCurrentUser' }),
    agentEmail() {
      return (this.currentUser && this.currentUser.email) || '';
    },
    toggleTitle() {
      if (this.isOpen) return 'Hide phone';
      return this.isRegistered
        ? 'Phone - you can receive calls'
        : 'Phone - open once to start receiving calls';
    },
    framePermissions() {
      // The panel is served from the bridge, so this iframe is cross-origin
      // and a bare "microphone" would delegate to same-origin frames only -
      // the browser then denies the mic and WebRTC registration fails with
      // an opaque error. Name the origin to actually delegate it.
      const origin = new URL(BRIDGE_BASE).origin;
      return `microphone ${origin}; autoplay ${origin}`;
    },
    frameUrl() {
      return (
        BRIDGE_BASE +
        '?secret=' + encodeURIComponent(BRIDGE_SECRET) +
        '&agent_email=' + encodeURIComponent(this.agentEmail)
      );
    },
  },
};
</script>

<style scoped>
.phone-dock {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 9990;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}
.phone-dock-frame {
  width: 340px;
  height: 520px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
}
.phone-dock-toggle {
  width: 48px;
  height: 48px;
  border: none;
  border-radius: 50%;
  background: #1f93ff;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
}
.phone-dock-toggle:hover {
  filter: brightness(1.1);
}
.phone-dock-toggle.needs-setup {
  background: #b54708;
}
.phone-dock-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #d92d20;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}
.phone-dock-toggle {
  position: relative;
}
</style>
